import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHnwi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M11.239 17.499a1.75 1.75 0 0 0 1.95 0l1.749-1.173a1.75 1.75 0 0 0 .731-1.842l-1.652-7.258a.75.75 0 0 0-1.462.333l1.652 7.258a.25.25 0 0 1-.105.263l-1.748 1.173a.25.25 0 0 1-.279 0l-1.752-1.176a.25.25 0 0 1-.104-.261l1.592-7.262a.75.75 0 1 0-1.465-.322l-1.593 7.263a1.75 1.75 0 0 0 .734 1.828l1.752 1.176Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.558 2.401a.75.75 0 0 0-.902 0L8.977 4.419a.75.75 0 0 0-.218.936l.9 1.786a.75.75 0 0 0 .67.413h3.557a.75.75 0 0 0 .67-.413l.9-1.786a.75.75 0 0 0-.22-.936L12.559 2.4ZM10.79 6.054l-.41-.814 1.727-1.301 1.727 1.3-.41.815H10.79Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M7.222 6.834a.75.75 0 1 0-.844-1.24L3.89 7.287a3.75 3.75 0 0 0-1.64 3.1v7.827A3.75 3.75 0 0 0 6 21.964h12a3.75 3.75 0 0 0 3.75-3.75v-7.827a3.75 3.75 0 0 0-1.64-3.1l-2.488-1.693a.75.75 0 1 0-.844 1.24l2.488 1.693a2.25 2.25 0 0 1 .984 1.86v7.827a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25v-7.827c0-.744.369-1.44.984-1.86l2.488-1.693Z"
    />
  </svg>
);
export default SvgTwoColorHnwi;
